"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4141],{

/***/ 24141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_JoinUsCareers; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./components/sections/JoinUsCareers/joinUsCareers.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    gap: 2rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 2rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 3rem;\n    line-height: 3.5rem;\n    letter-spacing: -0.0125rem;\n    margin-bottom: 2rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 3rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n    font-size: 3rem;\n    line-height: 3.5rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 2;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 42rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: auto;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.75rem 4rem;\n    max-width: 17.875rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 0;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 370px;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}





const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1ji8vxe0"
})("display:flex;flex-direction:column;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1ji8vxe1"
})(Typography/* ParagraphS */.fw, ";margin:0 0 1.5rem 0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1ji8vxe2"
})("font-size:2rem;line-height:2.5rem;font-weight:400;font-family:", theme/* THEME.font.questrial */.C.font.questrial, ";margin:0 0 1.5rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ji8vxe3"
})("flex:0 0 100%;position:relative;z-index:2;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";");
const ActionButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1ji8vxe4"
})("box-sizing:border-box;width:100%;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";font-size:1.25rem;line-height:2rem;border:none;border-radius:4rem;text-align:center;box-shadow:none;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";position:relative;padding:0.75rem 3rem;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";transition:background-color 300ms ease-in-out;text-decoration:none;display:inline-block;", mixins/* boxShadow */.Wn, ";&:before{content:'';z-index:-1;width:100%;height:100%;position:absolute;left:0;top:0;border-radius:4rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);}&:focus{outline:none;}&:hover{background-color:transparent;}", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";");
const PersonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ji8vxe5"
})("display:flex;flex-direction:column;align-items:center;margin-top:2.5rem;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";");
const PersonImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ji8vxe6"
})("width:170px;height:188px;border-radius:11px;img{width:170px;height:188px;border-radius:11px;}");
const PersonBio = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ji8vxe7"
})("max-width:343px;text-align:center;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";");
const BioText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1ji8vxe8"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";font-size:1rem;line-height:2rem;font-weight:300;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.nunito;
}, ";margin:1rem 0 0 0;");
const BioLinks = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ji8vxe9"
})("display:flex;flex-direction:column;");
const BioLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1ji8vxe10"
})("font-size:1rem;line-height:2rem;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./utils/phoneNumberFormatter.ts
var phoneNumberFormatter = __webpack_require__(38782);
;// CONCATENATED MODULE: ./components/sections/JoinUsCareers/JoinUsCareers.tsx






const JoinUsCareers = (param)=>{
    let { title , description , actionLabel , actionLink , id , titleAs , joinUsText , joinUsPhone , joinUsMail , joinUsImage  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
        id: id && id,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        as: titleAs && titleAs,
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                        children: description
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActionButton, {
                        href: actionLink,
                        children: actionLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonImageWrapper, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            ...(0,imageSerializer/* imageSerializer */.l)(joinUsImage)
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonBio, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BioText, {
                                children: joinUsText
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BioLinks, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BioLink, {
                                        href: "tel:".concat(joinUsPhone),
                                        children: (0,phoneNumberFormatter/* formatPhoneNumber */.u)(joinUsPhone)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BioLink, {
                                        href: "mailto:".concat(joinUsMail),
                                        children: joinUsMail
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/JoinUsCareers/index.ts

/* harmony default export */ var sections_JoinUsCareers = (JoinUsCareers);


/***/ }),

/***/ 38782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
const formatPhoneNumber = (number)=>{
    if (!number) return;
    if (number.length === 9) {
        return "".concat(number.slice(0, 3), " ").concat(number.slice(3, 6), " ").concat(number.slice(6, 9));
    } else if (number.length === 12) {
        return "".concat(number.slice(0, 3), " ").concat(number.slice(3, 6), " ").concat(number.slice(6, 9), " ").concat(number.slice(9, 12));
    } else return number;
};


/***/ })

}]);